import { Injectable } from '@angular/core';
import { OrganizationCreationOptions } from '../../../../../../../../common/src/options/organization-creation.options';
import { FormFactory } from "@magieno/angular-advanced-forms";
import { AdvancedFormButton } from "@magieno/angular-advanced-forms";
import { ButtonStyleEnum } from '@magieno/angular-advanced-forms';
import { ButtonTypeEnum } from '@magieno/angular-advanced-forms';
import { AdvancedForm } from "@magieno/angular-advanced-forms";

@Injectable()
export class OrganizationCreateFormFactory {
  constructor(private readonly formFactory: FormFactory) {
  }

  create(): AdvancedForm<OrganizationCreationOptions> {
    return this.formFactory.create(new OrganizationCreationOptions(), [new AdvancedFormButton('SAVE', ButtonStyleEnum.Primary, 'Continue', ButtonTypeEnum.Submit)]);
  }
}
